// 从 GSAP 库中导入核心模块和 ScrollTrigger 插件
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin";

// 预定义的动画函数
var numtimes = false;
function animateNum() {
    console.log(`动画执行了`,numtimes);
    if (numtimes === false) {
        $("#num1").animateNum(35, false, 500, 100);
        $("#num2").animateNum(13, false, 500, 100);
        $("#num3").animateNum(100, false, 500, 100);
        numtimes = true
    }
}
// function resetNum() {
//     $("#num1").text(0);
//     $("#num2").text(0);
//     $("#num3").text(0);
// }

// 在页面加载完成后执行以下代码
$(function () {
    // 注册 GSAP 的 ScrollTrigger 插件，以便使用其功能
    gsap.registerPlugin(ScrollTrigger, TextPlugin);

    // 设置分割点，用于区分桌面端和移动端的屏幕宽度
    let breakPoint = 800;

    // 创建 GSAP 的 matchMedia 实例，用于定义响应式动画
    let mm = gsap.matchMedia();

    // 添加响应式条件，区分桌面端和移动端
    mm.add({
        isDesktop: `(min-width: ${breakPoint}px)`, // 当屏幕宽度大于等于 breakPoint 时，满足 isDesktop 条件
        isMobile: `(max-width: ${breakPoint - 1}px)` // 当屏幕宽度小于 breakPoint 时，满足 isMobile 条件
    }, (context) => {
        // 获取当前匹配条件，判断是否为桌面端或移动端
        let { isDesktop, isMobile } = context.conditions;

        // 创建一个时间线 (timeline) 用于管理滚动触发动画
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".home-partner", // 指定触发器元素
                scrub: 1,         // 滚动时平滑动画效果
                end: "200%",      // 滚动结束点为触发器高度的 200%
                pin: true         // 固定触发器元素
            },
        });

        let duration_time = 5;  //移动持续的时间
        let move_distance = -25;   //移过的距离
        if (isMobile) {
            move_distance = -10;
        }

        /*----------------------------------------
        * 1、处理内容移动-总共19秒
        ----------------------------------------*/
        // 在时间线开始时添加 2 秒的等待时间
        tl.to({}, { duration: 2 }); //1-2

        // 第一组动画执行
        tl.to(".layered-animation-block .item:nth-child(1)", {  //3-7
            y: move_distance,
            duration: duration_time // 如果减少动画，则缩放比例较小，否则为 2 倍
        })
            .to(".layered-animation-block .item:nth-child(1) img:nth-child(2)", {  //3-7
                opacity: 0,
                duration: duration_time
            }, "<");
        // 第二组动画执行
        tl.to(".layered-animation-block .item:nth-child(2)", { //8-12
            y: move_distance,
            duration: duration_time // 如果减少动画，则缩放比例较小，否则为 2 倍
        })
            .to(".layered-animation-block .item:nth-child(2) img:nth-child(2)", { //8-12
                opacity: 1,
                duration: duration_time
            }, "<");
        // 第三组动画执行
        tl.to(".layered-animation-block .item:nth-child(3)", {  //13-17
            y: move_distance,
            duration: duration_time // 如果减少动画，则缩放比例较小，否则为 2 倍
        })
            .to(".layered-animation-block .item:nth-child(2) img:nth-child(2)", { //13-17
                opacity: 0,
                duration: 5
            }, "<")
            .to(".layered-animation-block .item:nth-child(3) img:nth-child(2)", {  //13-17
                opacity: 1,
                duration: 5,
            }, "<");

        // 在时间线开始时添加 2 秒的等待时间 
        tl.to({}, { duration: 2 })  //18-19

        // 如果用户未请求减少动画，则添加旋转动画

        // gsap.to(".box", {
        //     rotation: 360,   // 盒子旋转 360 度
        //     ease: "none",    // 不使用任何缓动效果
        //     duration: 5,     // 旋转动画持续 5 秒
        //     repeat: -1       // 无限循环
        // });


        // 设置盒子的文本，根据设备类型显示不同的内容
        // gsap.set(".box", {
        //     innerText: isDesktop ? "Desktop" : "Mobile" // 根据条件显示“Desktop”或“Mobile”
        // });

        /*----------------------------------------
        * 2.创建新的时间线处理整体移动-1-19
        ----------------------------------------*/
        // 创建一个新的平行时间线来处理整体移动
        let parallelTL = gsap.timeline();

        // 在时间线开始 4 秒后开始整体上移，并持续到时间线结束
        parallelTL.to(".layered-animation-block", {
            y: isDesktop?60:20,
            duration: 10, // 持续 6 秒，剩余的时间
        }, "+=5"); // 延迟 4 秒后开始执行，和其他动画同步

        // 将平行时间线添加到主时间线，确保它们平行执行
        tl.add(parallelTL, 0); // 这里 0 表示从主时间线的开始时刻启动平行时间线

        /*----------------------------------------
        * 3.创建新的时间线处理右侧内容移动-1-19
        ----------------------------------------*/
        let rightATL = gsap.timeline();
        rightATL
            // 第一部分
            // 切换H顶部样式-开始
            .to(".home-partner .right h3:nth-child(1),.home-partner .right .item:nth-child(1)", {  //3-7
                y: 0,
                duration: 5
            }, 0)
            .to(".home-partner .right h3:nth-child(1),.home-partner .right .item:nth-child(1)", {  //3-7
                opacity: 0,
                duration: 2
            }, "<")
            .to(".home-partner .right h3:nth-child(2),.home-partner .right .item:nth-child(2)", {  //3-7
                y: 0,
                opacity: 1,
                duration: 15
            }, "<")
            // 切换H样式-结束;

            //第二部分
            // 切换H顶部样式-开始
            .to(".home-partner .right h3:nth-child(2),.home-partner .right .item:nth-child(2)", {  //3-7
                y: 0,
                duration: 5,
                onComplete: () => animateNum(),
            }, 16)
            .to(".home-partner .right h3:nth-child(2),.home-partner .right .item:nth-child(2)", {  //3-7
                opacity: 0,
                duration: 2,
            }, "<")
            .to(".home-partner .right h3:nth-child(3),.home-partner .right .item:nth-child(3)", {  //3-7
                y: 0,
                opacity: 1,
                duration: 15,
            }, "<")
        // 切换H样式-结束;

        tl.add(rightATL, 2);

        // 可选：返回一个清理函数，用于移除事件监听或其他资源清理
        return () => console.log("cleanup");
    });
});
